export default __webpack_public_path__ + "static/media/gear.bd25a289.svg";